const NoFoundQuestionError = () => (
  <div className="text-center">
    <h1 className="text-xl font-bold">
      Something went wrong. Please try again later.
    </h1>
  </div>
);

export { NoFoundQuestionError };
